import React from 'react';
import {connect} from 'react-redux';
import {Dropdown, Form} from 'semantic-ui-react';

import DropdownInput from 'components/forms/BasicFormFields/DropdownInput';

const options = [
  {
    text: 'Hero Section',
    value: 'HERO'
  },
  {
    text: 'Break Group',
    value: 'BREAK_GROUP'
  },
  {
    text: 'Message Bar',
    value: 'MESSAGE_BAR'
  }
];

const HomepageItemOptions = (props) => {

    return options.length > 0 ? (
        <Form.Field>
            <p>
                {props.required ? (
                    <i className="asterisk icon inline"/>
                ) : ""}
            </p>
            <DropdownInput
                {...props}
                options={options}
                name="type"/>
        </Form.Field>
    ) : "";
};

const ConnectedHomepageItemOptions = connect(null, null)(HomepageItemOptions);

export default ConnectedHomepageItemOptions;



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/HomepageItemOptions.jsx